export default __webpack_public_path__ + "static/media/register.a93fbf3b.jpg";